import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";

import { FINANCE_PAYMENT_REQUEST_PAGE_SIZE, financePaymentRequestQueryKey } from "../config";
import { fetchFinancePaymentRequests } from "../repo/financePaymentRequestRepo";
import {
  financePaymentRequestListSearchParams,
  readFinancePaymentRequestListScope,
} from "../service/financePaymentRequestService";
import type { FinancePaymentRequestListScope } from "../types";

/**
 * 请款记录：按页取请款，按提交时间倒序；可切全部、待付款、我发起的，切换后回到第 1 页。
 * 选的是哪一项以地址为准（参数 `scope`），首次进入、刷新、页面开着时再从工作台跳过来都停在地址上的那一项；
 * 页码留在页面上，地址上的筛选一变就回到第 1 页。
 */
export function useFinancePaymentRequestListRuntime() {
  const [searchParams, setSearchParams] = useSearchParams();
  const scope = readFinancePaymentRequestListScope(searchParams);
  const [local, setLocal] = useState({ scope, page: 1 });
  const page = local.scope === scope ? local.page : 1;
  const list = useQuery({
    queryKey: [...financePaymentRequestQueryKey, "list", scope, page],
    queryFn: () => fetchFinancePaymentRequests(page, FINANCE_PAYMENT_REQUEST_PAGE_SIZE, scope),
    retry: false,
    refetchOnWindowFocus: false,
  });
  return {
    scope,
    /** 换筛选：写进地址，回到第 1 页。 */
    setScope(next: FinancePaymentRequestListScope) {
      setLocal({ scope: next, page: 1 });
      setSearchParams(financePaymentRequestListSearchParams(next));
    },
    page,
    setPage(nextPage: number) {
      setLocal({ scope, page: nextPage });
    },
    pageSize: FINANCE_PAYMENT_REQUEST_PAGE_SIZE,
    items: list.data?.items ?? [],
    total: list.data?.total ?? 0,
    loading: list.isFetching,
    error: list.isError,
    refresh() {
      void list.refetch();
    },
  };
}
